"use strict";

/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateRemoteServerResult = void 0;
/**
 * The response of RemoteServers CREATE_REMOTE_SERVER service
 */
var CreateRemoteServerResult = /** @class */function () {
  /**
   * Create a new CreateRemoteServerResult instance
   *
   * @param server  the remote server
   * @param errors  any errors that might have occurred
   */
  function CreateRemoteServerResult(server, errors) {
    this.server = server;
    this.errors = errors;
  }
  return CreateRemoteServerResult;
}();
exports.CreateRemoteServerResult = CreateRemoteServerResult;